import { cn } from "@omni/utils/styles";

import { RatingFieldChildProps } from "../ratingField.component";

export const StarIcon: React.FC<RatingFieldChildProps> = () => {
    return (
        <svg
            aria-hidden="true"
            fill="none"
            viewBox="0 0 34 34"
            className={cn(
                "tw:absolute tw:flex tw:items-center tw:justify-center tw:top-[0.8rem]",
                "tw:left-[0.8rem] tw:h-[calc(100%-1.6rem)] tw:w-[calc(100%-1.6rem)]"
            )}
        >
            <g
                className={cn(
                    "tw:stroke-[#ffc107] tw:stroke-[1.5px] tw:fill-white"
                )}
            >
                <path d="M16.3076923,1.76513255 L20.8381599,11.4172719 L31.0592597,12.978917 L23.6603835,20.5621906 L25.3975353,31.2117909 L16.3076923,26.1870493 L7.21784935,31.2117909 L8.95500108,20.5621906 L1.55612493,12.978917 L11.7772247,11.4172719 L16.3076923,1.76513255 Z"></path>
            </g>
        </svg>
    );
};
